import Vue from 'vue'

import store from './store'

import {format} from 'date-fns'

Vue.filter('uppercase', (value) => value.toUpperCase());

const number = (value, decimals=0) => {
	if (value == undefined || value == null || typeof value != "number")
		return undefined;
	let negative = false;
	if (value < 0) {
		negative = true;
		value = -value;
	}
	if (decimals === 0)
		value = value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	else
		value = value.toFixed(decimals).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	if (negative)
		return `-${value}`;
	return value;
}

Vue.use({
	install(Vue) {
		Vue.prototype.$number = number;
	}
});

Vue.filter('number', number);

Vue.filter('formatDate', (value, dateFormat=store.getters.company.settings.dateFormat) => {
	if (!value)
		return value;
	try {
		return format(new Date(value + (value.length === 10 ? 'T00:00:00' : '')), dateFormat);
	} catch (err) {
		return 'Invalid format';
	}
});

Vue.filter('formatDateTime', (value, dateFormat=`${store.getters.company.settings.dateFormat} ${store.getters.company.settings.timeFormat}`) => {
	if (!value)
		return value;

	try {
		return format(new Date(value.replace(/-/g, '/')), dateFormat);
	} catch (err) {
		return 'Invalid format';
	}
});

Vue.filter('currency', (value, currency, displayCurrency=false) => {
	const decimals = 2;
	const symbol = '$';

	if (value == undefined || value == null || typeof value != "number")
		return undefined;
	let negative = false;
	if (value < 0) {
		negative = true;
		value = -value;
	}
	if (decimals === 0)
		value = value.toFixed(0).replace(/(\d)(?=(\d{3})$)/g, '$1,');
	else
		value = value.toFixed(decimals).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	if (negative)
		value = `-${value}`;
	return `${symbol}${value}${displayCurrency ? ` ${currency}` : ''}`;
});

Vue.filter('duration', (duration) => {
	const hours = Math.trunc(duration / 60);
	const minutes = duration % 60;
	return `${hours} hrs, ${minutes} mins`;
});
